import Typewriter from "./TypeWriter";
import homeLogo from "../../public/mac2.png";
import ArrowRight from "../LogoSVG/ArrowRight";
import HomeImageLogoMobile from "./HomeImageLogoMobile";

function HomeMobile() {
  return (
    <div className="flex flex-col ">
      <div className="container mt-12 md:mt-24">
        <p className="mb-2 font-semibold text-[30px]">Hey, Minh here!</p>
        <p className="mb-4 text-gray-4">A glimpse into me.</p>
        <div className="mb-4 lg:mb-6 ">
          <Typewriter />
        </div>
      </div>

      <HomeImageLogoMobile />

      <div>
        <p className="mt-3 mb-4 mr-4 text-gray-5">
          An aspiring software engineer eager to learn and grow alongside
          talented people
        </p>
        <p className="mb-4 mr-4 text-custom-green">
          Always open to new opportunities, or simply a chat!
        </p>
        <p className="mb-4 mr-4 text-gray-5">
          When I'm not at my desk, I am probably playing football, at the gym,
          cooking, or at a local coffee shop :]
        </p>
        {/* <button
          className="flex flex-row flex-wrap mt-4 text-custom-green items-center mb-1"
          onClick={() => {
            window.open("/resume.pdf", "_blank");
          }}
        >
          <div className="mr-2 underline underline-offset-4">
            View Full Résumé (Oct 2024)
          </div>
          <ArrowRight
            isYellow
            className={`transition-transform duration-300 ease-in-out`}
          />
        </button> */}
      </div>
    </div>
  );
}

export default HomeMobile;
